export default class RecipientBankAccount {
  accountNumber: string;
  iban: string;
}
